import React, { useMemo, useContext } from 'react';
import { useSelector } from 'react-redux';

import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';

import { POPUPS } from '@common/constants/popups';
import { getAvailableDepositMethods } from '@app/dev/helpers/depositMethods';

import './style.scss';

const ChooseDepositMethodPopup = () => {
  const t = useTranslation();
  const [{ openPopup, closePopup }] = useContext(PopupContext);
  const user = useSelector((state) => state.user);

  const availableMethods = useMemo(() => getAvailableDepositMethods(user), [user]);

  return (
    <div className="popup-content popup-small choose-deposit-method">
      <h3 className="popup-title">{t('Deposit')}</h3>
      <div className="popup-main-content">
        <p className="text-center">{t('Please select your preferred deposit option')}</p>
        <div className="deposit-methods">
          {availableMethods.map((method) => (
            <button
              type="button"
              key={method.type}
              onClick={() => openPopup(POPUPS.DEPOSIT, { type: method.type })}
              className={`deposit-${method.type}-bg`}
            >
              <img
                src={method.logo}
                alt="deposit logo"
                width={24}
                height={24}
              />

              {method.name}
            </button>
          ))}
        </div>
        <div className="cash-method">
          <h3>
            <i className="global-icon icon-pay" />
            {t('Cash deposit')}
          </h3>
          <p>{t('Please insert the cash in the cash slot of the terminal to make a deposit')}</p>
        </div>
      </div>
      <button type="button" onClick={closePopup} className="popup-cancel-button">{t('Cancel')}</button>
    </div>
  );
};

export default ChooseDepositMethodPopup;
